import React from "react";
import "./AboutStyles/AboutSection.scss";
import teamData from "../../assets/data/teamdata";
import ParagraphAnimation from "../../components/TextAnimation/ParagraphAnimation";
const EngineeringExperts = () => {
  return (
    <div className="engineering-experts">
      <div className="fullscreen section light-section pt-5">
        <div className="row gy-4">
          <div className="col-12">
            <div className="section-header mb-4">
            <p className="title">
              <ParagraphAnimation>our group management team</ParagraphAnimation>
            </p>
     
              <p className="subtitle">
                With over 20+ years of experience, our team of expert engineers drives innovation and excellence in every project we undertake. Their deep industry knowledge and technical expertise enable us to deliver best-in-class engineering services and products.
              </p>
            </div>
          </div>
      
          <div className="container">
            <div className="row gy-4">
              {teamData.map((member, index) => (
                <div className="col-6 col-md-4 col-lg-3" key={index}>
                  <div className="team-card">
                    <div className="img-wrapper">
                      <img src={member.image} alt={member.name} className="img-fluid" />
                      <div className="team-overlay">
                        <p className="headline">{member.bio.headline}</p>
                        <ul className="bio-list">
                          {member.bio.points.map((point, i) => (
                            <li key={i}>{point}</li>
                          ))}
                        </ul>
                      </div>
                    </div>
                    <p className="team-name">{member.name}</p>
                    <p className="team-role">{member.role}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EngineeringExperts;
